import { createStyles, makeStyles } from '@material-ui/styles';
import palette from '../../../../theme/palette';

const style = () =>
  createStyles({
    root: {
      margin: '0',
      color: palette.danger.red,
      fontSize: '0.75rem'
    }
  });

const useStyle = makeStyles(style);
export default useStyle;
